import {
  FETCH_API_KEYS_REQUEST,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_FAILURE,
  CREATE_API_KEY_REQUEST,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_FAILURE,
  GET_API_KEY_REQUEST,
  GET_API_KEY_SUCCESS,
  GET_API_KEY_FAILURE,
  UPDATE_API_KEY_REQUEST,
  UPDATE_API_KEY_SUCCESS,
  UPDATE_API_KEY_FAILURE,
  DELETE_API_KEY_REQUEST,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_FAILURE,
  LIST_API_KEYS_REQUEST,
  LIST_API_KEYS_SUCCESS,
  LIST_API_KEYS_FAILURE,
  VALIDATE_API_KEY_REQUEST,
  VALIDATE_API_KEY_SUCCESS,
  VALIDATE_API_KEY_FAILURE,
} from "../actions/apiKeyRegistrationActions";

const initialState = {
  apiKeys: [],
  currentApiKey: null,
  loading: false,
  error: null,
  successMessage: null,
  stats: null,
  validationResult: null,
  totalCount: 0,
  hasMore: false,
};

const apiKeyRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch API Keys
    case FETCH_API_KEYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case FETCH_API_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeys: action.payload,
        error: null,
      };

    case FETCH_API_KEYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create API Key
    case CREATE_API_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeys: [...state.apiKeys, action.payload],
        successMessage: "API key created successfully!",
        error: null,
      };

    case CREATE_API_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get API Key
    case GET_API_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentApiKey: null,
      };

    case GET_API_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        currentApiKey: action.payload,
        error: null,
      };

    case GET_API_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentApiKey: null,
      };

    // Update API Key
    case UPDATE_API_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case UPDATE_API_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeys: state.apiKeys.map((apiKey) =>
          apiKey.apiKeyId === action.payload.apiKeyId
            ? { ...apiKey, ...action.payload }
            : apiKey
        ),
        currentApiKey:
          state.currentApiKey?.apiKeyId === action.payload.apiKeyId
            ? { ...state.currentApiKey, ...action.payload }
            : state.currentApiKey,
        successMessage: "API key updated successfully!",
        error: null,
      };

    case UPDATE_API_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Delete API Key
    case DELETE_API_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null,
      };

    case DELETE_API_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeys: state.apiKeys.filter(
          (apiKey) => apiKey.apiKeyId !== action.payload.apiKeyId
        ),
        currentApiKey:
          state.currentApiKey?.apiKeyId === action.payload.apiKeyId
            ? null
            : state.currentApiKey,
        successMessage: "API key deleted successfully!",
        error: null,
      };

    case DELETE_API_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // List API Keys
    case LIST_API_KEYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LIST_API_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeys: action.payload.apiKeys || [],
        totalCount: action.payload.totalCount || 0,
        hasMore: action.payload.hasMore || false,
        error: null,
      };

    case LIST_API_KEYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Validate API Key
    case VALIDATE_API_KEY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        validationResult: null,
      };

    case VALIDATE_API_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        validationResult: action.payload,
        error: null,
      };

    case VALIDATE_API_KEY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        validationResult: null,
      };

    // Clear messages
    case "CLEAR_API_KEY_MESSAGES":
      return {
        ...state,
        error: null,
        successMessage: null,
        validationResult: null,
      };

    // Clear current API key
    case "CLEAR_CURRENT_API_KEY":
      return {
        ...state,
        currentApiKey: null,
      };

    default:
      return state;
  }
};

export default apiKeyRegistrationReducer;
